module.exports = __webpack_public_path__ + "static/media/proust_quote.269273ad.png";